(function(){
    'use strict'

    angular
    .module('app.procesarPlanilla')
    .controller('PlanillaProcesada', PlanillaProcesada);

    PlanillaProcesada.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams', 'ProcesarPlanillaService', 'DepartamentosService', 'logger', '$location', 'UserInfoService', 'moment', 'CoreSrv'];

    function PlanillaProcesada($q, $scope, $animationsSrv, $routeParams, ProcesarPlanillaService, DepartamentosService, logger, $location, UserInfoService, moment, CoreSrv) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        var searchKey = "Planilla_Procesada_Search_Criteria";
        var previousSearchArray = UserInfoService.getDataFromSessionStorage(searchKey) || [];

        vm.planillaId = $routeParams.id ? $routeParams.id : 0;
        vm.planillaProcesada = [];
        vm.empleadosAAgregar = [];
        vm.verEmpleados = false;
        vm.departamentos = [];
        vm.busqueda = {
            departamentoId: -1,
            nombre: '',
            id: '',
            calendarizacionId: vm.planillaId,
            companiaId: UserInfoService.getCompaniaId()
        };

        vm.title = 'Planilla Procesada';

        var promiseDepartamento = getDepartamentos();
        CargarPreviousSearch();

        function CargarPreviousSearch(){

            var previousSearch = previousSearchArray.find(function(search) {
                return search.calendarizacionId == vm.planillaId;
            });

            if(previousSearch){

                vm.busqueda = previousSearch;
                $q.all([promiseDepartamento]).then(function(){

                    vm.search();
                });               
            }
            else{
                getAll();
            }

        }

        function getAll(){

            if(vm.planillaId){
                var promise = ProcesarPlanillaService.getPlanillaProcesada(vm.planillaId)
                .then(function(planillaProcesada){
                    vm.planillaProcesada = planillaProcesada.sort(CoreSrv.dynamicSort("nombre"));
                })
                .catch(function(error){
                    logger.error('Error al obtener los datos de la planilla procesada.');
                }); 
            }
            else{
                logger.error('No se ha definido la planilla.');
            }
        
        };

        vm.goToDetalle = function(planillaProcesada){
            
            var path = '/planillaProcesada-detalle/';

            if(planillaProcesada){
                $location.path(path + planillaProcesada.calendarizacionId + '/' + planillaProcesada.id);
            }
            else{
                logger.error('No fue posible cargar los datos del detalle del empleado');
            }
            
        };

        function saveSearchCriteria(){
            var elementFound = false;
            previousSearchArray.forEach(element => {
                if(element.calendarizacionId === vm.busqueda.calendarizacionId)
                {
                    element = vm.busqueda;
                    elementFound = true;
                }
            });
            if(!elementFound)
            {
                previousSearchArray.push(vm.busqueda);
            }

            UserInfoService.saveDataOnSessionStorage(searchKey, previousSearchArray);
        };

        vm.search = function(){

            if(vm.planillaId){

                var promise = ProcesarPlanillaService.searchPlanillaProcesada(vm.busqueda)
                .then(function(planillaProcesada){
                    saveSearchCriteria();
                    vm.planillaProcesada = planillaProcesada.data.sort(CoreSrv.dynamicSort("nombre"));
                })
                .catch(function(error){
                    logger.error('Error al obtener los datos de la planilla procesada.');
                });
                
                return promise;
            }
            else{
                logger.error('No se ha definido la planilla.');
            }
        
        };

        vm.verEmpleadosAAgregar = function(){

            if(vm.planillaId){
                var promise = ProcesarPlanillaService.getEmpleadosAAgregarEnPlanilla(vm.planillaId)
                .then(function(empleadosAAgregar){
                    vm.verEmpleados = true;
                    vm.empleadosAAgregar = empleadosAAgregar.sort(CoreSrv.dynamicSort("nombre"));
                })
                .catch(function(error){
                    logger.error('Error al obtener los datos de los empleados a agregar.');
                }); 
            }
            else{
                logger.error('No se ha definido la planilla.');
            }
        
        };

        vm.agregarEmpleado = function(empleado){
            
            if(vm.planillaId){

                var promise = ProcesarPlanillaService.agregarEmpleado(vm.planillaId, empleado.id)
                .then(function(result){
                    vm.verEmpleados = false;
                    vm.search().then(function(){
                        logger.success('Empleado agregado.');
                    });
                })
                .catch(function(error){
                    logger.error('Error al agregar el empleadoa a la planilla.');
                }); 
            }
            else{
                logger.error('No se ha definido la planilla.');
            }
        };

        vm.clearCriteria = function(){
            vm.busqueda.id = '';
            vm.busqueda.nombre = '';
            vm.busqueda.departamentoId = -1; 
        };

        function getDepartamentos(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                logger.error('Error al obtener los departamentos.');
            }); 
            
            return promise;
        };

        vm.cerrar = function(){

            if(vm.planillaId){

                var planillaObject = {
                 id: vm.planillaId
                };
                var promise = ProcesarPlanillaService.cerrar(planillaObject)
                .then(function(result){
                    logger.success('Planilla cerrada con éxito.');
                    $location.path('/procesarPlanilla');
                })
                .catch(function(error){
                    logger.error('Error al cerrar la planilla. ');
                    console.log(error);
                }); 
            }
            else{
                logger.error('No se ha definido la planilla.');
            }
        
        };

        vm.eliminarEmpleado = function(datos){

            var promise = ProcesarPlanillaService.eliminarEmpleado(datos)
            .then(function(result){
                vm.planillaProcesada = vm.planillaProcesada.filter(function(g) {
                    return g.id !== datos.id;
                }); 
                logger.success('Empleado eliminado con éxito.');
            })
            .catch(function(error){
                logger.error('Error al eliminar el empleado: ' + error.data.Message);
                console.log(error);
            }); 
        
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

    }
})();